if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.previousButton = this.querySelector('[data-media-previous]');
        this.nextButton = this.querySelector('[data-media-next]');
        this.currentCounter = this.querySelector('[data-media-current]');
        this.totalCounter = this.querySelector('[data-media-total]');
        this.navigation = this.querySelector('.hamrooq-media-viewer__controls');

        this.navigation?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.previousButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.changeMedia(-1);
        });
        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.changeMedia(1);
        });
        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowLeft') this.changeMedia(-1);
          if (event.code === 'ArrowRight') this.changeMedia(1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        this.updateNavigation();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]')).filter(
          (item) => !item.classList.contains('product__media-item--variant'),
        );
      }

      changeMedia(direction) {
        const items = this.mediaItems;
        if (items.length < 2) return;

        const activeIndex = Math.max(
          0,
          items.findIndex((item) => item.classList.contains('active')),
        );
        const nextIndex = (activeIndex + direction + items.length) % items.length;

        items[activeIndex].classList.remove('active');
        items[nextIndex].classList.add('active');
        this.updateNavigation();
      }

      updateNavigation() {
        const items = this.mediaItems;
        const activeIndex = Math.max(
          0,
          items.findIndex((item) => item.classList.contains('active')),
        );

        if (this.currentCounter) this.currentCounter.textContent = activeIndex + 1;
        if (this.totalCounter) this.totalCounter.textContent = items.length;
        if (this.previousButton) this.previousButton.disabled = items.length < 2;
        if (this.nextButton) this.nextButton.disabled = items.length < 2;
      }
    },
  );
}
